var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex grow justify-center"},[_c('fancy-image-uploader',{staticClass:"inline-block bg-gray-500 hover:bg-purple text-white py-2 px-4 rounded-md focus:outline-none focus:ring",on:{"select-image":_vm.uploadImage}},[_vm._v("\n        Select Image\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }